module.exports = __webpack_public_path__ + "static/media/DATA-COLLECTION.39c64eac.svg";